import type { ButtonHTMLAttributes, ReactNode } from "react";

/** `role`, `tag`, `status` i `outline` pochodzą z design systemu; reszta z prototypu panelu. */
export type ChipVariant = "role" | "tag" | "status" | "accent" | "danger" | "outline" | "pack";

export function Chip({
  variant = "role",
  children,
  className,
  title,
}: {
  variant?: ChipVariant;
  children: ReactNode;
  className?: string;
  title?: string;
}) {
  return (
    <span className={["ui-chip", `ui-chip--${variant}`, className ?? ""].filter(Boolean).join(" ")} title={title}>
      {children}
    </span>
  );
}

/** Pigułka hero z pulsującą kropką „na żywo" — 1:1 z komponentem `Pill` design systemu. */
export function Pill({ children, dot = true, className }: { children: ReactNode; dot?: boolean; className?: string }) {
  return (
    <span className={["ui-pill", className ?? ""].filter(Boolean).join(" ")}>
      {dot ? <span className="ui-pill__dot" /> : null}
      {children}
    </span>
  );
}

interface TogglePillProps extends Omit<ButtonHTMLAttributes<HTMLButtonElement>, "onChange"> {
  active: boolean;
  onToggle?: () => void;
}

/** Przełączalna pigułka — filtry kategorii, kanały komunikacji klienta. */
export function TogglePill({ active, onToggle, children, className, ...rest }: TogglePillProps) {
  return (
    <button
      type="button"
      aria-pressed={active}
      onClick={onToggle}
      className={["ui-togglepill", className ?? ""].filter(Boolean).join(" ")}
      {...rest}
    >
      {children}
    </button>
  );
}
